import HttpQuery from "@mnjsplatform/data/lib/api/HttpQuery";

export default class SubFinanceApi {
    static getDocumentLink(controller, rowKeys) {
        let hq = new HttpQuery();
        return hq.makeApiCallPost(`${controller}/GetDocumentLink`, {rowKeys});
    }
}
